import {Component, EventEmitter, Injector, Input, Output} from '@angular/core';
import { MatFormFieldControl } from '@angular/material';
import { AbstractMatFormFieldControl } from '@mctic/ng-core';

@Component({
  selector: 'app-currency',
  providers: [{provide: MatFormFieldControl, useExisting: CurrencyComponent}],
  template: `
    <input
      matInput
      currencyMask
      placeholder="0,00"
      [options]="{allowNegative: allowNegative, prefix: prefix, thousands: '.', decimal: ',',
      integerLimit: 2,
  requireDecimal: true
      }"
      [ngClass]="{'text-right': align === 'right', 'text-left': align === 'left'}"
      [formControl]="formControl"
      [maxLength]="maxlength"
      [readonly]="readonly"
      (blur)="onBlur()"
    >
  `
})
export class CurrencyComponent extends AbstractMatFormFieldControl<number> {

  @Input() prefix = '';
  @Input() maxlength = '18';
  @Input() allowNegative = false;
  @Input() align: 'right' | 'left' = 'right';
  @Input() readonly = false;
  @Output() blur: EventEmitter<void> = new EventEmitter<void>();

  constructor(injector: Injector) {
    super(injector);
  }

  onBlur(): void {
    if (!!this.blur) {
      this.blur.emit();
    }
  }

}
